<script setup>
import { inject } from "vue";

import BaseTooltip from "../BaseTooltip.vue";
import SvgIcon from "../SvgIcon.vue";

defineOptions({ inheritAttrs: false });

const menuOpen = inject("dropdownOpen");
</script>

<template>
  <BaseTooltip text="More actions" :disabled="menuOpen">
    <span aria-label="More actions" v-bind="$attrs">
      <SvgIcon name="system/more-vertical" width="18" height="18" />
    </span>
  </BaseTooltip>
</template>
